import { z } from "zod";

export const ICON_TYPES = [
  "badge-check",
  "book",
  "bookmark",
  "briefcase",
  "building-thick",
  "calendar",
  "caret-double-left",
  "caret-double-right",
  "centered-circle",
  "chart-line-increase",
  "clock",
  "cogwheel",
  "coordinates-person",
  "clipboard-bunny-gold",
  "dash",
  "dollar",
  "door-straight",
  "ellipsis",
  "files",
  "folder-person",
  "folder-view",
  "gps-disabled",
  "group",
  "house-building",
  "hybrid-view",
  "information-circle",
  "location-alt",
  "magnifying-glass",
  "medal-star-alt",
  "message",
  "microscope",
  "money-dollar",
  "notepad-alt",
  "notepad-problem",
  "padlock-locked",
  "palm-dollar",
  "people",
  "person-male",
  "person-male-formal",
  "person-superstar",
  "plus",
  "profile",
  "question-circle",
  "replay",
  "ribbon",
  "route",
  "stack-vertical",
  "student",
  "variant",
  "triangle-down",
] as const;

export type IconType = typeof ICON_TYPES[number];

export const iconTypeSchema = z.enum(ICON_TYPES);
